<template>
  <div ref="holder" class="holder" :style="holderstyle">
    <div ref="symbolholder" :class="symbolholderclasses">
      <div class="presymbol"><span :class="iconbackclasses" /></div>
      <div class="symbol"><span :class="iconfrontclasses" /></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/custom-bootstrap.scss';
.holder {
  width: #{5 * $base-size}px;
  height: #{5 * $base-size}px;
  position: absolute;
  user-select: none;
  touch-action: none;
  pointer-events: none;
}
</style>

<script>
import $ from 'jquery'
import _ from 'lodash'

import { workflow_grid_step } from '@/utils.js'
import { icon_from_name } from './workflow_common.js'

import { WorkflowCanvasBrickGhostHandler } from './workflow_core.vue'

// *****************************************************************************

export default {
  name: 'WorkflowCanvasBrickGhost',
  props: ['workflow_interface', 'options'],
  data() {
    let res = {}
    return res
  },
  computed: {
    symbolholderclasses() {
      let res = ['symbolholderdefault']
      return res
    },
    iconbackclasses() {
      let t = icon_from_name(this.workflow_interface.current_brick)
      let res = t.iconbackclasses
      return res
    },
    iconfrontclasses() {
      let t = icon_from_name(this.workflow_interface.current_brick)
      let res = t.iconfrontclasses
      return res
    },
    holderstyle() {
      let { x, y } = this.options.position
      x -= workflow_grid_step
      y -= workflow_grid_step
      let style = `transform: translate(${x}px, ${y}px)`
      return style
    },
  },
  mounted() {
    this.handler = new WorkflowCanvasBrickGhostHandler(this)
    this.workflow_interface.install(this.handler)
  },
  beforeDestroy() {
    this.handler.stop()
    this.workflow_interface.uninstall(this.handler)
  },
  methods: {},
}
</script>
